import styled from "styled-components";
import {breakpoints, colors, typograph} from "~/styles";

const { weight, size } = typograph;
const { gray } = colors;

export const View = styled.div`
  margin-top: 8rem;
  margin-bottom: 6.4rem;

  b {
    color: ${gray._400};
    font-weight: ${weight.bold};
  }

  @media screen and (max-width: ${breakpoints.md}) {
    .header {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr);
      white-space: nowrap;

      & > div,
      & > a {
        margin: 0 0 1.6rem !important;
        display: flex;
        justify-content: flex-start;
        font-size: ${size.s3};

        :nth-of-type(even) {
          padding-left: 3.2rem;
        }
      }
    }
  }
`;

export const ProcessLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  font-size: 1.3rem;
  color: #0d6efd;
`;

export const LastUpdate = styled.span`
  margin-left: auto;
  font-size: 1.2rem;
  color: #6c757d;
`;
